import React, { useState, useEffect, useRef } from "react";
import "../CodeBook/CodeBook.css";


const EARLY_MESSAGES = [
  "Setting up your environment...",
  "Getting things ready for you...",
  "Preparing your workspace...",
];

const SLOW_MESSAGES = [
  "Downloading reference data — this can take a little longer on slower connections...",
  "Still working — large reference files are being downloaded and prepared...",
];


const VERY_SLOW_MESSAGE =
  "This is taking longer than usual. Large files can take up to a minute on slower networks — hang tight, it's still working.";

const SLOW_THRESHOLD_MS = 8000;
const VERY_SLOW_THRESHOLD_MS = 25000;
const ROTATE_INTERVAL_MS = 2200;

const getConnectionInfo = () => {
  const conn =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;
  if (!conn) return null;
  return {
    effectiveType: conn.effectiveType, // "slow-2g" | "2g" | "3g" | "4g"
    saveData: conn.saveData,
  };
};

const isKnownSlowConnection = (info) =>
  !!info && (info.effectiveType === "slow-2g" || info.effectiveType === "2g");

const CodebookLoader = () => {
  const [elapsedMs, setElapsedMs] = useState(0);
  const [messageIndex, setMessageIndex] = useState(0);
  const startTimeRef = useRef(Date.now());
  const connectionInfoRef = useRef(getConnectionInfo());

  useEffect(() => {
    const tick = setInterval(() => {
      setElapsedMs(Date.now() - startTimeRef.current);
    }, 1000);
    return () => clearInterval(tick);
  }, []);

  useEffect(() => {
    const rotate = setInterval(() => {
      setMessageIndex((prev) => prev + 1);
    }, ROTATE_INTERVAL_MS);
    return () => clearInterval(rotate);
  }, []);

  const connectionKnownSlow = isKnownSlowConnection(connectionInfoRef.current);

  let message;
  if (elapsedMs >= VERY_SLOW_THRESHOLD_MS) {
    message = VERY_SLOW_MESSAGE;
  } else if (connectionKnownSlow || elapsedMs >= SLOW_THRESHOLD_MS) {
    message = SLOW_MESSAGES[messageIndex % SLOW_MESSAGES.length];
  } else {
    message = EARLY_MESSAGES[messageIndex % EARLY_MESSAGES.length];
  }

  return (
    <div className="codebook-loading-overlay">
      <div className="codebook-loading-spinner" />

      <div className="codebook-loading-text" key={message}>
        {message}
      </div>
    </div>
  );
};

export default CodebookLoader;